import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ButtonComponent } from '@libs/common/components';
import { ShopErrorItemModel } from '@libs/shop/models';
import { OrderUnavailableProductsComponent } from '../order-unavailable-products.component';

export interface OrderUnavailableProductsDialogFormData {
  unavailableProductsErrors: ShopErrorItemModel[];
}

@Component({
  selector: 'ui-order-unavailable-products-dialog-form',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    OrderUnavailableProductsComponent,
    ButtonComponent,
  ],
  templateUrl: './order-unavailable-products-dialog-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './order-unavailable-products-dialog-form.component.scss',
})
export class OrderUnavailableProductsDialogFormComponent {
  public readonly data: OrderUnavailableProductsDialogFormData = inject<OrderUnavailableProductsDialogFormData>(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<OrderUnavailableProductsDialogFormComponent, boolean> =
    inject<MatDialogRef<OrderUnavailableProductsDialogFormComponent, boolean>>(MatDialogRef);

  public close(): void {
    this.dialogRef.close(false);
  }

  public deleteAndOrder(): void {
    this.dialogRef.close(true);
  }
}
